import styled from 'styled-components';
import { useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { Text } from '../../../../components/common/Texts';
import { Img } from '../../../../components/common/Image';

// Material UI
import { Button } from '@mui/material';

// Assets
import giftAnimation from '../../../../assets/media/gif/animacion-referidos.gif';

// Hooks
import useRedirect from '../../../../hooks/useRedirect';
import CommonButton from '../../../../components/common/CommonButton';
import ReactCardFlip from 'react-card-flip';
import { Link, Email } from '@material-ui/icons';
import {
    LinkedinShareButton,
    LinkedinIcon,
    FacebookMessengerShareButton,
    FacebookIcon,
    TwitterShareButton,
    XIcon,
    WhatsappShareButton,
    WhatsappIcon,
    EmailShareButton,
    EmailIcon,
} from 'react-share';
import toast from 'react-hot-toast';
import { referralCopyLink } from '../../../../redux/api/behaviour/referrals';
import { useGetGeolocationStatus } from '../../hooks/useGelocationStatus';

const MyReferralsCard = () => {
    //HOOKS
    const { handleRedirection } = useRedirect();
    const repoId = useSelector((state) => state?.auth?.user?.repo_id);
    const { countryCode } = useGetGeolocationStatus();

    const [flip, setFlip] = useState(false);

    const rewards = [
        {
            text: 'por cada invitado que se matricule en un MBA o Doctorado.',
            amount: 200,
        },
        { text: 'por cada invitado que curse una Maestría.', amount: 100 },
        { text: 'por cada invitado que se inscriba en un Major.', amount: 75 },
        {
            text: 'por cada invitado que elija un Programa Especializado.',
            amount: 50,
        },
    ];

    const argRewards = [
        {
            text: 'por cada invitado que se inscriba en un MBA o Maestría.',
            amount: '220.000',
        },
        {
            text: 'por cada invitado que se inscriba en un Programa de Formación Ejecutiva, Programa Especializado o Major.',
            amount: '75.000',
        },
    ];

    const getInvitationLink = () => {
        const baseUrl = window.location.origin;
        return `${baseUrl.replace('/campus', '')}/invitado/${repoId}`;
    };

    const handleCopyLink = async () => {
        const invitationLink = getInvitationLink();
        referralCopyLink({ partner_id: repoId });

        try {
            await navigator.clipboard.writeText(invitationLink);
            toast.success('Enlace de invitación copiado!', {
                icon: <Link />,
                style: {
                    border: '2px solid #4BB543',
                    padding: '16px',
                    color: '#000',
                    fontWeight: 'bold',
                },
            });
        } catch (err) {
            console.error('Error al copiar el enlace:', err);
        }
    };

    return (
        <Wrapper>
            <ReactCardFlip flipDirection="horizontal" isFlipped={flip}>
                <CardWrapper>
                    <Text color="#B31D15" fontSize="20px" fontWeight="700">
                        Mis invitados
                    </Text>
                    <Image src={giftAnimation} w="30" />
                    <TextWrapper>
                        <Text color="#222222" fontSize="20px" fontWeight="400">
                            ¡Recomienda ADEN, <br />
                            <b>
                                <i>y gana recompensas!</i>
                            </b>
                        </Text>
                    </TextWrapper>
                    <TextButtonWrapper>
                        <Text
                            textAlign="center"
                            color="#222222"
                            fontSize="15px"
                            fontWeight="300"
                        >
                            Por cada persona que se matricule gracias a ti,
                            obtienes un premio.
                        </Text>
                        <CommonButton
                            onClick={() => setFlip(!flip)}
                            width="55%"
                            variant="filled"
                            label="Invita ahora"
                        />
                    </TextButtonWrapper>
                    {/*<ReferralsButton
                        onClick={() => handleRedirection('/mis-referidos')}
                        variant="contained"
                        data-behaviour-action={'home_referir'}
                        // Event detail
                        data-behaviour-detail={JSON.stringify(comportamientoInfo)}
                    >
                        Invitá ahora
                    </ReferralsButton>*/}
                </CardWrapper>
                <CardWrapper onClick={() => setFlip(!flip)}>
                    <Text color="#B31D15" fontSize="20px" fontWeight="700">
                        💰 ¿Qué ganas?
                    </Text>
                    <RewardsContainer>
                        {countryCode !== 'AR' &&
                            rewards.map((r, ind) => (
                                <Text
                                    key={ind}
                                    color="#222222"
                                    fontSize="16px"
                                    fontWeight="400"
                                >
                                    <b>
                                        <i>{r.amount} USD →</i>
                                    </b>{' '}
                                    {r.text}
                                </Text>
                            ))}
                        {countryCode === 'AR' &&
                            argRewards.map((r, ind) => (
                                <Text
                                    key={ind}
                                    color="#222222"
                                    fontSize="16px"
                                    fontWeight="400"
                                >
                                    <b>
                                        $<i>{r.amount} ARS →</i>
                                    </b>{' '}
                                    {r.text}
                                </Text>
                            ))}
                    </RewardsContainer>
                    <ShareButtonsWrapper onClick={(e) => e.stopPropagation()}>
                        <LinkedinShareButton url={getInvitationLink()}>
                            <LinkedinIcon size={40} round={true} />
                        </LinkedinShareButton>
                        <FacebookMessengerShareButton url={getInvitationLink()}>
                            <FacebookIcon size={40} round={true} />
                        </FacebookMessengerShareButton>
                        <TwitterShareButton url={getInvitationLink()}>
                            <XIcon size={40} round={true} />
                        </TwitterShareButton>
                        <WhatsappShareButton url={getInvitationLink()}>
                            <WhatsappIcon size={40} round={true} />
                        </WhatsappShareButton>
                        <EmailShareButton url={getInvitationLink()}>
                            <EmailIcon
                                size={40}
                                round={true}
                                bgStyle={{ fill: '#b31d15' }}
                            />
                        </EmailShareButton>
                    </ShareButtonsWrapper>
                    <CommonButton
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCopyLink();
                        }}
                        width="100%"
                        variant="filled"
                        label="Copiar enlace de invitación"
                    />
                    <Text
                        color="#222222"
                        fontSize="16px"
                        fontWeight="300"
                        textAlign="center"
                    >
                        Comparte tu enlace y empieza a ganar.{' '}
                        <b
                            style={{ color: '#B31D15', cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRedirection('/mis-referidos');
                            }}
                        >
                            Ver información completa →
                        </b>
                    </Text>
                </CardWrapper>
            </ReactCardFlip>
        </Wrapper>
    );
};

export default MyReferralsCard;

const Wrapper = styled.section`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;

    @media (max-width: 1265px) {
        width: 100%;
    }
`;

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    width: 256px;
    height: 436px;
    border-radius: 30px;
    background-color: #fbfbfb;
    z-index: 1;
    box-shadow:
        0px 3px 6px 0px rgba(0, 0, 0, 0.16),
        0px 3px 6px 0px rgba(0, 0, 0, 0.23);
    padding: 2rem;

    @media (max-width: 1440px) {
        width: calc(100% - 4rem);
    }
`;

const TextWrapper = styled.div`
    width: 100%;
    padding: 0rem 1.2rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
        display: inline-block;
    }

    b {
        color: #b31d15;
        font-size: 18px;
        font-weight: 900;
    }
`;

const TextButtonWrapper = styled.div`
    width: 100%;
    padding: 0rem !important;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
`;

const Image = styled(Img)`
    width: 180px;
    height: 180px;
    background-color: #fff;
`;

const RewardsContainer = styled.section`
    text-align: center;
    gap: 12px;
    display: flex;
    align-items: center;
    flex-direction: column;

    b {
        color: #b31d15;
        font-weight: 800;
    }
`;

const ShareButtonsWrapper = styled.section`
    display: flex;
    gap: 0.5rem;
`;

const ReferralsButton = styled(Button)`
    border-radius: 50px;
    padding: 0.5rem 1.5rem;
`;
